import React from "react";
import {
  Box,
  Flex,
  HStack,
  Icon,
  Text,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";

// Compact stat chip used in the summary bar of the payouts Configurations tab.
const StatCard = ({ icon, label, value, accent, bg }) => {
  const labelColor = useColorModeValue("gray.500", "gray.400");
  const valueColor = useColorModeValue("gray.800", "white");
  const cardBg = useColorModeValue("white", "whiteAlpha.100");
  const cardBorder = useColorModeValue("gray.100", "whiteAlpha.100");
  return (
    <HStack
      spacing={3}
      px={4}
      py={3}
      borderRadius="xl"
      bg={cardBg}
      border="1px solid"
      borderColor={cardBorder}
      minW="140px"
      position="relative"
      overflow="hidden"
      _hover={{
        boxShadow: "0 6px 16px rgba(31, 38, 135, 0.1)",
        transform: "translateY(-2px)",
        borderColor: accent,
      }}
      transition="all 0.25s ease"
    >
      {/* Accent gradient strip */}
      <Box
        position="absolute"
        top={0}
        left={0}
        w="4px"
        h="100%"
        bg={accent}
        opacity={0.85}
      />
      {/* Subtle gradient backdrop */}
      <Box
        position="absolute"
        top={0}
        right={0}
        w="60px"
        h="100%"
        bg={bg}
        opacity={0.5}
        style={{
          maskImage: "linear-gradient(to left, black, transparent)",
          WebkitMaskImage: "linear-gradient(to left, black, transparent)",
        }}
      />
      <Flex
        align="center"
        justify="center"
        w="40px"
        h="40px"
        borderRadius="lg"
        bg={bg}
        color={accent}
        position="relative"
        zIndex={1}
      >
        <Icon as={icon} boxSize={5} />
      </Flex>
      <VStack align="start" spacing={0} position="relative" zIndex={1}>
        <Text
          fontSize="10px"
          fontWeight="semibold"
          color={labelColor}
          textTransform="uppercase"
          letterSpacing="wider"
        >
          {label}
        </Text>
        <Text fontSize="2xl" fontWeight="bold" color={valueColor} lineHeight="1">
          {value}
        </Text>
      </VStack>
    </HStack>
  );
};

export default StatCard;
